import { Box, IconButton, Tooltip } from '@mui/material'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'

import { SectionHeading } from '@/components/atoms/SectionHeading'
import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'
import { RADIUS } from '@/shared/styles/radii'

// section 見出し行. 見出しはラベルのみ (チェックボックスを持たない) で、 行頭チェックボックスを
// 持つ本文行と視覚的に明確に分ける (28 spec: 白い紙のメタファー / 見出しと本文はタイポ階層で
// 区別). 採否はあくまで行単位 (SoapLine の行頭チェックボックス) が担い、 見出しには一括除外の
// 操作を置かない (= UI エントロピー最小化. 見出し = ラベル + コピー のみ).
//   - 見出しラベルは左レール (行頭) に置き、 下の行頭チェックボックス列の頭に載せる.
//   - コピーは頻用の重要操作なので右端に常時表示 (28 spec anti-pattern: 重要操作を hover で
//     隠さない. log/171 の先方 FB でも常時表示に確定). 見出し行クリックでのコピーも維持.
// `showCopyButton` を持たない見出し (フォローアップ / ハイライト等) はクリックコピーのみ.
export const CopyableHeading = ({
  label,
  title,
  onCopy,
  showCopyButton = false,
}: {
  label: string
  title: string
  onCopy: () => void
  showCopyButton?: boolean
}) => (
  <Box
    onClick={onCopy}
    sx={{
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      borderRadius: `${RADIUS.sm}px`,
      px: 0.5,
      mx: -0.5,
      transition: 'background-color 120ms',
      // 見出し行 *全体* を hover の当たりにする (= 行どこを押してもコピー. 本文行が「行まるごと
      // が当たり」なのと同じ単位感).
      '&:hover': { bgcolor: colorTokens.overlay.hover },
    }}
  >
    <Tooltip title={title} placement="top">
      <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
        <SectionHeading>{label}</SectionHeading>
      </Box>
    </Tooltip>
    {showCopyButton && (
      <Box sx={{ ml: 'auto', pl: 1, display: 'flex', alignItems: 'center' }}>
        <Tooltip title="このセクションをコピー" placement="top">
          <IconButton
            aria-label="このセクションをコピー"
            size="small"
            onClick={(e) => {
              e.stopPropagation()
              onCopy()
            }}
            sx={{
              width: 24,
              height: 24,
              borderRadius: `${RADIUS.sm}px`,
              color: colorTokens.fg.faint,
              transition: 'color 120ms, background-color 120ms',
              '&:hover': {
                color: colorTokens.fg.muted,
                bgcolor: colorTokens.overlay.active,
              },
            }}
          >
            <ContentCopyIcon sx={{ fontSize: 16 }} />
          </IconButton>
        </Tooltip>
      </Box>
    )}
  </Box>
)
